import { useStore, useStoreMap } from 'effector-react'
import { useMemo } from 'react'
import { inspectionModel } from '~/entities/Inspection'
import { Details } from '~/features/Inspection/Details'
import { InspectionReasonCodeEnum } from '~/shared/config/enums'
import { canShowObject } from '~/shared/lib/utils'
import {
  QuickNavigation,
  QuickNavigationOptions,
  QuickNavigationOption,
} from '~/shared/ui/QuickNavigation'

export function DetailsPage() {
  const reasonCode = useStoreMap(inspectionModel.$inspection, (inspection) =>
    inspection?.getReason()?.getCode(),
  )
  const isLoading = useStore(inspectionModel.requestInspectionFx.pending)

  const quickNavigationOptions: QuickNavigationOptions = useMemo(
    () =>
      [
        ...canShowObject<QuickNavigationOption>(
          !isLoading && reasonCode === InspectionReasonCodeEnum.REFUND,
          {
            labelI18n: 'form.security service',
            anchor: 'safety',
          },
        ),
        { labelI18n: 'form.main information', anchor: 'main' },
        { labelI18n: 'form.state', anchor: 'state' },
        { labelI18n: 'form.documents', anchor: 'documents' },
        { labelI18n: 'form.completeness', anchor: 'equipments' },
        { labelI18n: 'form.service', anchor: 'service' },
        { labelI18n: 'form.wheels', anchor: 'wheels' },
        { labelI18n: 'form.photos', anchor: 'photos' },
      ].filter(
        (provideStatus): provideStatus is QuickNavigationOption =>
          !!provideStatus,
      ),
    [isLoading, reasonCode],
  )

  return (
    <>
      <Details />

      <QuickNavigation options={quickNavigationOptions} />
    </>
  )
}
